<script lang="ts">
  export let show: boolean;
  export let loading: boolean = false;
  export let message: string;
  export let body: string | null = null;
  export let details: Record<string, unknown> | null = null;
  export let title: string = "Sync Result";
  export let onClose: () => void;
  export let onConfirm: (() => void) | null = null;
  export let confirmLabel = "Confirm";
  export let cancelLabel = "Cancel";
  export let closeLabel = "Close";
  export let variant: "info" | "danger" = "info";
  export let downloadBody: string | null = null;
  export let downloadFileName: string | null = null;

  $: titleClass = variant === "danger" ? "text-red-400" : "text-green-400";

  const downloadFile = () => {
    if (!downloadBody || !downloadFileName) return;
    const blob = new Blob([downloadBody], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = downloadFileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };
</script>

{#if show}
  <div class="fixed inset-0 flex items-center justify-center z-50" style="background: var(--ace-overlay, rgba(14,17,30,0.72))">
    <div class="rounded-xl shadow-lg w-[500px] p-6 text-center border" style="background: var(--ace-panel, #292d40); border-color: var(--ace-border, rgba(226,232,240,0.22))">
      <h2 class={`text-xl font-bold mb-4 ${titleClass}`}>{title}</h2>

      {#if loading}
        <div class="flex flex-col items-center justify-center gap-3 py-6">
          <div class="w-9 h-9 rounded-full border-[3px] border-white/20 border-t-white animate-spin"></div>
          <p class="text-sm" style="color: var(--ace-text-muted, #dbe3f0)">{message}</p>
        </div>
      {:else}
        <p class="mb-4 text-sm" style="color: var(--ace-text-muted, #dbe3f0)">{message}</p>

        {#if body}
          <pre class="text-left text-sm p-3 rounded w-full max-w-full overflow-auto max-h-60 whitespace-pre-wrap break-words border" style="background: var(--ace-surface, #25293a); color: var(--ace-text-muted, #dbe3f0); border-color: var(--ace-border-subtle, rgba(226,232,240,0.14))">{body}</pre>
        {/if}

        {#if details}
          <pre class="text-left text-sm p-3 rounded w-full max-w-full overflow-auto max-h-60 whitespace-pre-wrap break-words border" style="background: var(--ace-surface, #25293a); color: var(--ace-text-muted, #dbe3f0); border-color: var(--ace-border-subtle, rgba(226,232,240,0.14))">{JSON.stringify(details, null, 2)}</pre>
        {/if}
      {/if}

      <div class="mt-4 flex justify-center gap-4">
        {#if loading}
          <button
            class="px-4 py-2 rounded-lg shadow hover:opacity-80 transition-opacity text-sm font-medium border"
            style="background: var(--ace-button, #35364d); color: var(--ace-text, #f8fafc); border-color: var(--ace-border, rgba(226,232,240,0.22))"
            on:click={onClose}
          >
            {closeLabel}
          </button>
        {:else}
          {#if downloadBody && downloadFileName}
            <button
              class="px-4 py-2 rounded-lg shadow hover:opacity-80 transition-opacity text-sm font-medium border"
              style="background: var(--ace-button, #35364d); color: var(--ace-text, #f8fafc); border-color: var(--ace-border, rgba(226,232,240,0.22))"
              on:click={downloadFile}
            >
              Download log
            </button>
          {/if}
          {#if onConfirm}
            <button
              class="px-4 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700 text-sm font-medium"
              on:click={onConfirm}
            >
              {confirmLabel}
            </button>
            <button
              class="px-4 py-2 rounded-lg shadow hover:opacity-80 transition-opacity text-sm font-medium border"
              style="background: var(--ace-button, #35364d); color: var(--ace-text, #f8fafc); border-color: var(--ace-border, rgba(226,232,240,0.22))"
              on:click={onClose}
            >
              {cancelLabel}
            </button>
          {:else}
            <button
              class="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 text-sm font-medium"
              on:click={onClose}
            >
              {closeLabel}
            </button>
          {/if}
        {/if}
      </div>
    </div>
  </div>
{/if}
